module.exports = __webpack_public_path__ + "img/header-engagementRingsUsa@2x.80c49d5.jpg";